<template>
  <div v-if="!isAuthenticated" class="login-wrapper">
    <div class="login-container">
      <!-- Main Logo -->
      <img src="../assets/WTA.png" alt="Main Logo" class="logo" />

      <h2></h2>
      <form @submit.prevent="handleLogin">
        <label>Username</label>
        <input type="text" v-model="username" required class="input-field" />

        <label>Password</label>
        <input type="password" v-model="password" required class="input-field" />

        <button type="submit" class="login-btn">Login</button>
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
      </form>
    </div>
  </div>

  <div v-else class="glow-border">
    <event-select v-bind:tournament-data="tournamentData"></event-select>
  </div>
</template>

<script>
import EventSelect from "./EventSelect.vue";

export default {
  name: "Event",
  props: {
    tournamentData: Array,
  },
  components: {
    "event-select": EventSelect,
  },
  data() {
    return {
      username: "",
      password: "",
      isAuthenticated: false,
      errorMessage: "",
    };
  },
  methods: {
    handleLogin() {
      const hardcodedUsername = "admin@wta";
      const hardcodedPassword = "wta2025";

      if (this.username === hardcodedUsername && this.password === hardcodedPassword) {
        this.isAuthenticated = true;
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("loginTimestamp", Date.now());
      } else {
        this.errorMessage = "Invalid username or password";
      }
    },
    checkSession() {
      const storedAuth = localStorage.getItem("isAuthenticated");
      const loginTimestamp = localStorage.getItem("loginTimestamp");

      if (storedAuth === "true" && loginTimestamp) {
        const elapsedTime = Date.now() - parseInt(loginTimestamp, 10);
        const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

        if (elapsedTime < twentyFourHours) {
          this.isAuthenticated = true;
        } else {
          this.logout();
        }
      }
    },
    logout() {
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("loginTimestamp");
      this.isAuthenticated = false;
      this.username = "";
      this.password = "";
      this.errorMessage = "";
    }
  },
  mounted() {
    this.checkSession();
  }
};
</script>

<style scoped>
/* Prevent scrolling on the entire page */
html, body {
  height: 100vh;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

/* Full-page background without scrolling */
.login-wrapper {
  position: fixed; /* Ensures the page does not move */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh; /* Cover the full screen */
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('../assets/WTABackground.jpg'); /* Replace with your image */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* Login box */
.login-container {
  width: 600px;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  background: rgba(0, 0, 0, 0.95);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  border-width: 4px;
  border-style: solid;
  border-image: linear-gradient(to right, #00ff00, #00ffff) 1;
}

/* Logo */
.logo {
  width: 400px;
  display: block;
  margin: 0 auto 20px;
}

/* Input Fields */
.input-field {
  width: 90%;
  padding: 10px;
  margin: 10px 0;
  border-radius: 5px;
  border: 1px solid #0cb77bd1;
}

/* Login Button */
.login-btn {
  background: linear-gradient(to right, #01d16d, #00edc9);
  color: #4b006e;
  padding: 10px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-weight: bold;
  font-size: 16px;
  margin-top: 10px;
  width: 300px;
}

/* Error Message */
.error {
  color: red;
}

</style>
